<script setup lang="ts">
/** Share Application Form — Corporate Shareholder */
import { computed, inject } from 'vue';
import CddVarField from '../incorporation-pre/cdd/CddVarField.vue';
import { DOC_SCOPE } from '../incorporation-pre/cdd/useCddFill';
import SgPostSigners from './SgPostSigners.vue';
import { shareCorpSignersKey } from './sgPostSignersContext';
import './allotDoc.css';

const scope = inject(DOC_SCOPE, '');
const signersKey = computed(() => {
  const m = String(scope || '').match(/^share_corp_(\d+)\//);
  return shareCorpSignersKey(m?.[1] || 1);
});
</script>

<template>
  <div class="allot-doc">
    <div class="doc-head">
      <div class="doc-lbl-title" style="text-align:center; font-size:15px">SHARE APPLICATION FORM</div>
      <div class="doc-meta">(Corporate Shareholder)</div>
    </div>

    <p class="doc-p">Date: <CddVarField field-key="application_date" label="Application Date" /></p>
    <p class="doc-p">
      To:<br />
      The Secretary,<br />
      <CddVarField field-key="company_name" label="Company Name" /><br />
      <CddVarField field-key="company_registered_address" label="Company Registered Address" />
    </p>
    <p class="doc-p">Dear Sir / Madam,</p>
    <p class="doc-lbl-title">APPLICATION FOR SHARES</p>
    <p class="doc-p">We hereby apply for an allotment of shares in the above-named company and provide the following information:</p>

    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Company Name</td><td><CddVarField field-key="corporate_shareholder_name" label="Corporate Shareholder Name" /></td></tr>
        <tr><td class="cdd-lcell">Registration No.</td><td><CddVarField field-key="corporate_shareholder_registration_no" label="Registration No." /></td></tr>
        <tr><td class="cdd-lcell">Country of Incorporation</td><td><CddVarField field-key="corporate_shareholder_country" label="Country of Incorporation" /></td></tr>
        <tr><td class="cdd-lcell">Registered Office Address</td><td><CddVarField field-key="corporate_shareholder_address" label="Registered Office Address" /></td></tr>
        <tr><td class="cdd-sec" colspan="2">Share Allotment Details</td></tr>
        <tr><td class="cdd-lcell">No. of Shares</td><td><CddVarField field-key="number_of_shares" label="No. of Shares" /></td></tr>
        <tr><td class="cdd-lcell">Type of Shares</td><td><CddVarField field-key="type_of_shares" label="Type of Shares" /></td></tr>
        <tr><td class="cdd-lcell">Currency</td><td><CddVarField field-key="currency_symbol" label="Currency" /></td></tr>
        <tr><td class="cdd-lcell">Amount Payable</td><td><CddVarField field-key="amount_payable" label="Amount Payable" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p" style="margin-top:12px">We hereby agree to be bound by the Constitution of the Company.</p>
    <p class="doc-p" style="margin-top:16px">Yours faithfully,</p>
    <p class="doc-p">For and on behalf of <CddVarField field-key="corporate_shareholder_name" label="Corporate Shareholder Name" /></p>
    <div class="sig-block">
      <div class="sig-line">____________________________________</div>
      <div>Name: <CddVarField field-key="representative_name" label="Representative Name" /></div>
      <div>Designation: <CddVarField field-key="representative_title" label="Representative Title" /></div>
      <div>(Authorised Representative of the Corporate Shareholder)</div>
    </div>
    <SgPostSigners :var-key="signersKey" board-label="AUTHORISED REPRESENTATIVE" />
  </div>
</template>
